import React from 'react';

interface IconFlagProps {
    iconClasses?: string;
}

const IconFlag: React.FC<IconFlagProps> = ({ iconClasses }) => {
    return (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-flag ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M2 1C2 0.447715 2.44772 0 3 0C3.55228 0 4 0.447715 4 1V15C4 15.5523 3.55228 16 3 16C2.44772 16 2 15.5523 2 15V1Z"
                fill="currentColor"
            />
            <path
                d="M4 1.75C7 0.25 9.5 3.25 13 1.75V8.75C9.5 10.25 7 7.25 4 8.75V1.75Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconFlag;
